import Yup from '@fourthwall/utils/dist/yup';
export const getValidationSchema = (maxValue) => Yup.object().shape({
    quantity: Yup.number()
        .required()
        .min(1)
        .max(maxValue || 999),
});
